import axios from "axios";
import { getData, setData, removeData } from "../utiles/CookieUtile";
import uRLs from "../utiles/BaseUtile";
import { createToken } from "../services/authService";

let isRefreshing = false;
let refreshSubscribers = []; 

const axiosInstance = axios.create({
  baseURL: uRLs.SALE_BASE_URL,
  headers: { "Content-Type": "application/json" },
});


const setupInterceptors = (instance) => {
  instance.interceptors.request.use((config) => {
    const token = getData("accessToken");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });


  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

     if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        if (!isRefreshing) {
          isRefreshing = true;
        const refreshToken = getData("refreshToken");
        try {
          const newToken = await createToken(refreshToken);
          if (newToken) {
            setData("accessToken", newToken);
            originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
            return instance(originalRequest); 
          }
        } catch (err) {
          removeData("accessToken");
          removeData("refreshToken");
          window.location.href = "/login";
          return Promise.reject(err);
        }
        finally {
          isRefreshing = false;
        }
      }
      return new Promise((resolve) => {
        refreshSubscribers.push((newToken) => {
          originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
          resolve(instance(originalRequest));
        });
      });
    }
      return Promise.reject(error);
    }
  );
};
setupInterceptors(axiosInstance);


export const apiRequest = async (method, url, data = {}, instance = axiosInstance) => {
  try {
    const response = await instance({
      method,
      url,
      data,
      params: method === "GET" ? data : undefined,
    });
    return response.data;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export { axiosInstance}; 
export default axiosInstance;